// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u5Dsh","left":"styles_left__3zwiF"};